import { roundHelper } from './round.helper.class.js';

export class FormulaHelper {
	calculateBmi(data: { heightInCm: number; weightInKg: number }): number {
		return roundHelper.roundTo(data.weightInKg / Math.pow(data.heightInCm / 100, 2), 2);
	}
}

export const formulaHelper = new FormulaHelper();
